import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [passwordCheck, setPasswordCheck] = useState('');
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // ✅ this gives you the token from the URL
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const showError = (message) => {
    setSuccess('');
    setError(message);
    setTimeout(() => setError(''), 5000);
  };

  const showSuccess = (message) => {
    setError('');
    setSuccess(message);
    setTimeout(() => setSuccess(''), 3000);
  };

  const validatePassword = (password) => {
    const hasCapitalLetter = /[A-Z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
    const hasNumber = /[0-9]/.test(password);

    return hasCapitalLetter && hasSpecialChar && hasNumber;
  };

  const handleReset = async () => {
    if (password.length < 6) {
      showError('Password must be six characters long');
      return;
    }
    if (password !== passwordCheck) {
      showError('Passwords must match');
      return;
    }

    if (!validatePassword(password)) {
      showError('Password must contain both a capital letter, special character, and number');
      return;
    }

    try {
      const res = await axios.put('/api/forgotpassword', { token, newpassword: password });
      showSuccess(res.data.message);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        showError(err.response.data.message); // ✅ proper access
      } else {
        showError('An unexpected error occurred.'); // fallback
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-layout">
        <aside className="auth-hero">
          <div>
            <p className="auth-hero__eyebrow">Password recovery</p>
            <h1 className="auth-hero__title">Reset your password</h1>
            <p className="auth-hero__copy">Pick something strong so your account stays secure.</p>
          </div>

          <div className="auth-hero__notes">
            <span className="auth-hero__note">Capital letter</span>
            <span className="auth-hero__note">Special character</span>
            <span className="auth-hero__note">Number</span>
          </div>
        </aside>

        <section className="auth-card" style={{ animation: 'slideUp 0.6s ease-out' }}>
          <h2 className="auth-card__title">Password Reset</h2>
          <p className="auth-card__copy">
            Your new password must include a capital letter, a special character, and a number.
          </p>

          {error && <div className="auth-status is-error">{error}</div>}
          {success && <div className="auth-status is-success">{success}</div>}

          <form
            className="auth-form"
            onSubmit={(e) => {
              e.preventDefault();
              handleReset();
            }}
          >
            <div className="auth-field">
              <label className="auth-label">Enter New Password</label>
              <div className="auth-input-wrap">
                <input
                  className="auth-input"
                  type={isPasswordVisible ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={() => setIsPasswordVisible((v) => !v)}
                  className="auth-toggle"
                >
                  {isPasswordVisible ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <div className="auth-field">
              <label className="auth-label">Enter Password Again</label>
              <div className="auth-input-wrap">
                <input
                  className="auth-input"
                  type={isPasswordVisible ? 'text' : 'password'}
                  value={passwordCheck}
                  onChange={(e) => setPasswordCheck(e.target.value)}
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  onClick={() => setIsPasswordVisible((v) => !v)}
                  className="auth-toggle"
                >
                  {isPasswordVisible ? '🙈' : '👁️'}
                </button>
              </div>
            </div>

            <div className="auth-actions">
              <button type="submit" className="auth-submit">
                Reset Password
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
}

export default ResetPassword;
